import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 13/14;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 14 13" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.452 8.467a.613.613 0 1 1-.868-.868l1.734-1.733a.612.612 0 0 1 .87.002L8.92 7.598a.613.613 0 1 1-.868.868l-.686-.686v5.873a.614.614 0 1 1-1.227 0V7.781l-.687.686zm5.29 2.124H9.205a.614.614 0 0 1 0-1.227h1.537a1.534 1.534 0 0 0 0-3.069h-.88l-.086-.512a3.07 3.07 0 0 0-6.052 0l-.086.512h-.88a1.534 1.534 0 0 0 0 3.069h1.537a.614.614 0 0 1 0 1.227H2.758a2.761 2.761 0 0 1-.115-5.52C2.923 3.64 4.644 2 6.75 2a4.298 4.298 0 0 1 4.124 3.089c1.353 0 2.626 1.217 2.626 2.74a2.762 2.762 0 0 1-2.758 2.762z" transform="translate(0 -2)" fill={color} fillRule="nonzero"/>
    </svg>
)

export default class IconUpload extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
